import { StatusPill, StatusPillProps } from "components/shared/pills/StatusPill";

type BlueStatusPillProps = StatusPillProps;

export const BlueStatusPill = (props: BlueStatusPillProps) => {
  return (
    <StatusPill {...props} textColor="text-blue-800" backgroundColor="bg-blue-100" iconBackgroundColor="bg-blue-500" />
  );
};
